/* eslint no-irregular-whitespace: "error" */

import React, { useEffect, useState, useCallback } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { RootState, Dispatcher } from 'AppTypes'
import { connect } from 'react-redux'
import { getIconByName } from '@share/helper'
import moment from 'moment'
import VideoPopup from '@features/top/popup/VideoPopup'
import * as actions from './state_management/actions'
import './style.scss'

const mapStateToProps = (state: RootState) => ({
  searchStores: state.searchStore.searchStores,
  priceRanges: state.searchStore.priceRanges,
  foodCategoryGroups: state.searchStore.foodCategoryGroups
})

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  fetchDataSearch: (params: any) => dispatch(actions.fetchDataSearch(params)),
  getFoodCategoryGroup: () => dispatch(actions.getFoodCategoryGroup()),
  getPriceRange: () => dispatch(actions.getPriceRange())
})
const latitudeField: number = 0
const longitudeField: number = 0
const page = 1
const limit = 30
type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const SearchStore: React.FC<Props> = ({
  searchStores,
  foodCategoryGroups,
  priceRanges,
  getFoodCategoryGroup,
  getPriceRange,
  fetchDataSearch
}) => {
  const search = useLocation().search
  const newDate = new Date()
  const day = newDate.getDay()
  const hour = newDate.getHours()
  const [latitude, setLatitude] = useState(latitudeField)
  const [longitude, setLongitude] = useState(longitudeField)
  const [showVideoPopup, setShowVideoPopup] = useState(false)
  const [selectedVideo, setSelectedVideo] = useState()
  const [selectedCategory, setSelectedCategory] = useState('')
  const [selectedPrice, setSelectedPrice] = useState('')
  const [filterDate, setFilterDate] = useState('')
  const [selectedTime, setSelectedTime] = useState(false)

  const clearFilter = () => {
    setFilterDate('')
    setSelectedPrice('')
    setSelectedCategory('')
  }

  const formatDateTime = () => {
    const dateString = moment(newDate).format('YYYY-MM-DD')
    const hourString = moment(newDate).format('HH:mm:ss')
    return `${dateString}T${hourString}Z`
  }

  const fetchApiSearchStore = useCallback(() => {
    const params: any = {
      PageIndex: page,
      PageSize: limit
    }
    const keyword = new URLSearchParams(search).get('keyword')
    const lat = new URLSearchParams(search).get('lat')
    const long = new URLSearchParams(search).get('long')
    const locationDistance = new URLSearchParams(search).get('locationDistance')
    const markId = new URLSearchParams(search).get('markId')

    if (keyword) params.Keyword = keyword
    if (lat) params.Lat = lat
    if (long) params.Long = long
    if (markId) params.MarkId = markId
    if (locationDistance) params.LocationDistance = locationDistance
    if (selectedCategory) params.FoodCategoryGroups = selectedCategory
    if (selectedPrice) params.Price = selectedPrice
    if (filterDate) params.OpenTime = filterDate
    fetchDataSearch(params)
  }, [fetchDataSearch, filterDate, search, selectedCategory, selectedPrice])

  const getTimeOpen = (times: any[]) => {
    let strTime: string = ''
    const indexTime = times.findIndex((val: any) => val.dayOfWeek === day)
    if (indexTime !== -1 && times[indexTime].timeRanges && times[indexTime].timeRanges.length) {
      const timeRanges = times[indexTime].timeRanges[0]
      const timeRangeOpen = timeRanges.open
      const timeRangeClose = timeRanges.close
      strTime = `${timeRangeOpen.hour && timeRangeOpen.hour < 10 ? 0 : ''}${timeRangeOpen.hour}:${timeRangeOpen.minute < 10 ? 0 : ''}${timeRangeOpen.minute} 
        ~ ${timeRangeClose.hour && timeRangeClose.hour < 10 ? 0 : ''}${timeRangeClose.hour}:${timeRangeClose.minute < 10 ? 0 : ''}${timeRangeClose.minute}`
    }
    return strTime
  }

  const getTrueTime = (times: any[]) => {
    const indexTime = times.findIndex((val: any) => val.dayOfWeek === day)
    if (indexTime !== -1 && times[indexTime].timeRanges && times[indexTime].timeRanges.length) {
      const timeRanges = times[indexTime].timeRanges[0]
      if (timeRanges.open) {
        return true
      }
    }
    return false
  }

  const getOpenDoor = (times: any[]) => {
    let textOpen = ''
    const indexTime = times.findIndex((val: any) => val.dayOfWeek === day)
    if (indexTime !== -1 && times[indexTime].isOff === false
      && times[indexTime].timeRanges && times[indexTime].timeRanges.length) {
      const timeRanges = times[indexTime].timeRanges[0]
      if (timeRanges.open.hour <= hour && timeRanges.close.hour >= hour) {
        textOpen = '[営業中]  '
      }
    }
    return textOpen
  }

  const getPriceRanges = (priceRangeStore: any[]) => {
    let strPriceRanges: string = ''
    const first = priceRangeStore[0] && priceRangeStore[0].from && priceRangeStore[0].to ? `[昼] ¥${priceRangeStore[0].from.toLocaleString()} 〜 ¥${priceRangeStore[0].to.toLocaleString()} ` : ''
    const last = priceRangeStore[1] && priceRangeStore[1].from && priceRangeStore[1].to ? `[夜] ¥${priceRangeStore[1].from.toLocaleString()} 〜 ¥${priceRangeStore[1].to.toLocaleString()} ` : ''
    strPriceRanges = `${first}    ${last}`
    return strPriceRanges
  }

  const getDistanceFromLatLonInKm = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const R = 6371 // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1) // deg2rad below
    const dLon = deg2rad(lon2 - lon1)
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
      * Math.sin(dLon / 2) * Math.sin(dLon / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const d = R * c // Distance in km
    return Math.ceil(d)
  }
  const deg2rad = (deg: number) => (
    deg * (Math.PI / 180)
  )

  const getLocation = (locationStore: string) => {
    const arrLocationStore = JSON.parse(`[${locationStore}]`)
    const value = getDistanceFromLatLonInKm(arrLocationStore[0], arrLocationStore[1],
      latitude, longitude)
    if (value > 100) return '~ 100 Km'
    return `${value} Km`
  }

  const onSelectVideo = (video: any) => {
    setSelectedVideo(video)
    setShowVideoPopup(true)
  }

  const onCloseVideoPopup = () => {
    setShowVideoPopup(false)
  }

  useEffect(() => {
    fetchApiSearchStore()
  }, [search, selectedCategory, selectedPrice, filterDate, fetchApiSearchStore])

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position: any) => {
      setLatitude(position.coords && position.coords.latitude)
      setLongitude(position.coords && position.coords.longitude)
    })
    getFoodCategoryGroup()
    getPriceRange()
  }, [getFoodCategoryGroup, getPriceRange])

  return (

    <div className="main-detail">
      <div className="fillter-shop">
        <div className="mt-3 fillter-list">
          <button type="button" onClick={clearFilter} className="btn btn-lg btn-outline-secondary w-auto me-2"><img src="/assets/img/sort-icon.png" alt="" /></button>
          <button
            type="button"
            className={`btn btn-lg btn-outline-secondary me-2 ${selectedTime ? 'selected-time' : null}`}
            onClick={() => {
              if (!selectedTime) {
                setFilterDate(formatDateTime)
                setSelectedTime(true)
              } else {
                setFilterDate('')
                setSelectedTime(false)
              }
            }}
          >
            現在営業中
          </button>
          <select
            className="select-fillter-1"
            value={selectedPrice}
            onChange={(e: any) => setSelectedPrice(e.target.value)}
          >
            <option value="">価格帯</option>
            {
              priceRanges && priceRanges.length
              && priceRanges.map((val: any) =>
                <option value={val.from}>{`¥${val.from.toLocaleString()}~¥${val.to.toLocaleString()}`}</option>)
            }
          </select>
          <select
            className="select-fillter-2"
            value={selectedCategory}
            onChange={(e: any) => setSelectedCategory(e.target.value)}
          >
            <option value="">料理の種類</option>
            {
              foodCategoryGroups && foodCategoryGroups.length
              && foodCategoryGroups.map((val: any) =>
                <option value={val.id}>{val.name}</option>)
            }
          </select>
        </div>
      </div>
      <div className="shop-list">
        {selectedVideo
          && (
            <VideoPopup
              video={selectedVideo}
              showModal={showVideoPopup}
              onCloseModal={onCloseVideoPopup}
            />
          )}
        {
          searchStores && searchStores.map((val: any) => (
            <div key={val.id} className="shop-items">
              <div className="shop-items-col">
                {
                  val.videos && val.videos.length ? (
                    <div className="shop-items-left pe-0">
                      <div className="video-items" data-content={val.videos[0].title} role="presentation" onClick={() => onSelectVideo(val.videos[0])}>
                        <i className="bi bi-play-circle-fill play-icon" />
                        {val.videos[0].thumbnailUrl
                          ? <img src={val.videos[0].thumbnailUrl} alt={val.videos[0].title} />
                          : (
                            <video height="100%" width="100%">
                              <source src={val.videos[0].url} type="video/mp4" />
                              <track kind="captions" />
                              Your browser does not support HTML video.
                            </video>
                          )}
                      </div>
                    </div>
                  ) : <div className="shop-items-left" style={{ background: "url('assets/img/default-bg.png')", backgroundSize: 'cover', backgroundPosition: '0 50%', backgroundRepeat: 'no-repeat' }}> </div>

                }

                <div className="shop-items-right">
                  <div className="shop-desc">
                    <h2> <Link to={`/shop/${val.id}`}>{val.storeName}</Link></h2>
                    <div className="shop-icon d-flex align-items-center mb-1">
                      {
                        val.foodCateGroups && val.foodCateGroups.length ? <button type="button" className="btn btn-sm btn-outline me-2"><img src={getIconByName(val.foodCateGroups[0].name)} alt={val.foodCateGroups[0].name} /> {val.foodCateGroups[0].name === 'その他' ? 'ホテル' : val.foodCateGroups[0].name}</button> : null
                      }
                      {
                        val.location
                          ? <button type="button" className="btn btn-sm btn-pubple me-2">{getLocation(val.location)}</button>
                          : null
                      }
                      <img className=" me-2" src="/assets/img/shop-icon-1.png" height="50" alt="" />
                      <img className=" me-2" src="/assets/img/shop-icon-2.png" height="50" alt="" />
                    </div>
                    <div className="text">
                      {
                        val.businessSchedule && val.businessSchedule.workingDays
                          && getTrueTime(val.businessSchedule.workingDays)
                          ? <div> <span className="open-door">{getOpenDoor(val.businessSchedule.workingDays)}</span> 営業時間：{getTimeOpen(val.businessSchedule.workingDays)} </div>
                          : null
                      }
                      {
                        val.priceRanges && val.priceRanges.length
                          ? <div className="price-range">{getPriceRanges(val.priceRanges)}</div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        }

      </div>
    </div>

  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchStore)
